const GOOGLE_MAPS_SCRIPT_SELECTOR = 'script[src*="maps.googleapis.com/maps/api/js"]'

const isGoogleMapsReady = () =>
  typeof window !== 'undefined' && Boolean(window.google?.maps?.Geocoder)

const LocationService = {
  getLocation: () => {
    return new Promise((resolve, reject) => {
      fetch(
        'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyB_Gob1-ls7DqnjHbJHhpDJ81WN2xFK0ig',
        {
          method: 'POST',
        },
      )
        .then((response) => response.json())
        .then((data) => {
          const location = data?.location
          resolve(location)
        })
        .catch((error) => reject(error))
    })
  },

  getCountry: (location) => {
    return new Promise((resolve, reject) => {
      if (!isGoogleMapsReady()) {
        reject('Google Maps API is not loaded')
        return
      }

      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ location }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          const addrComponents = results[0]?.address_components || []
          for (let i = 0; i < addrComponents.length; i++) {
            if (addrComponents[i].types[0] === 'country') {
              const countryCode = addrComponents[i].short_name
              resolve(countryCode)
            }
          }
        } else {
          reject(`Geocode was not successful for the following reason: ${status}`)
        }
      })
    })
  },
  initializeMaps: () => {
    console.log('initializing maps')
    if (isGoogleMapsReady()) {
      if (typeof window.initialize === 'function') {
        window.initialize()
      }
      return
    }

    const existingMapsScript = document.querySelector(GOOGLE_MAPS_SCRIPT_SELECTOR)
    if (window.__aumhumGoogleMapsScriptLoading || existingMapsScript) {
      console.log('Google Maps Script already loading')
      return
    }

    window.__aumhumGoogleMapsScriptLoading = true
    var script = document.createElement('script')
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyB_Gob1-ls7DqnjHbJHhpDJ81WN2xFK0ig&callback=initialize&loading=async'
    script.async = true
    script.onerror = () => {
      window.__aumhumGoogleMapsScriptLoading = false
      console.warn('Google Maps API failed to load')
    }
    document.head.appendChild(script)
    console.log('Google Maps Script Added')
  },
}

export default LocationService
